import React from 'react'

import { APP_ROUTES } from '../../../common/constants'
import { useDocumentTitle } from '../../../common/hooks'

import { useCreateSopMutation } from '../../hooks'
import { SopCreateForm } from '../forms'

const SopCreatePage = () => {
  useDocumentTitle(APP_ROUTES.MISC.children.SOPS.children.SOP_CREATE.label)

  const [createSop, { isLoading, error }] = useCreateSopMutation()

  return (
    <SopCreateForm onSubmit={createSop} isLoading={isLoading} error={error} />
  )
}

export default SopCreatePage
